"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Tue Mar 05 2019
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ForecastSimulationConflictDTO_1 = require("../model/ForecastSimulationConflictDTO");

var ForecastSimulationConflictDTOConverter_1 = require("./ForecastSimulationConflictDTOConverter");

var ForecastSimulationConflictNodeDTOConverter_1 = require("./ForecastSimulationConflictNodeDTOConverter");
/**
 * @author BPo
 * @author Tomas Leity
 */


var ForecastSimulationConflictDTOConverterImpl =
/*#__PURE__*/
function (_ForecastSimulationCo) {
  _inherits(ForecastSimulationConflictDTOConverterImpl, _ForecastSimulationCo);

  function ForecastSimulationConflictDTOConverterImpl(conflictNodeConverter) {
    var _this;

    _classCallCheck(this, ForecastSimulationConflictDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForecastSimulationConflictDTOConverterImpl).call(this));
    _this.conflictNodeConverter = conflictNodeConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ForecastSimulationConflictDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new ForecastSimulationConflictDTO_1.ForecastSimulationConflictDTO(conversions.asObjectList(source, 'updatedWindows', function (document) {
        return _this2.conflictNodeConverter.toObject(document, conversions);
      }), conversions.asObjectList(source, 'updatedWindowItems', function (document) {
        return _this2.conflictNodeConverter.toObject(document, conversions);
      }), conversions.asObjectList(source, 'insertedWindows', function (document) {
        return _this2.conflictNodeConverter.toObject(document, conversions);
      }), conversions.asObjectList(source, 'insertedWindowItems', function (document) {
        return _this2.conflictNodeConverter.toObject(document, conversions);
      }), conversions.asObjectList(source, 'deletedWindows', function (document) {
        return _this2.conflictNodeConverter.toObject(document, conversions);
      }), conversions.asObjectList(source, 'deletedWindowItems', function (document) {
        return _this2.conflictNodeConverter.toObject(document, conversions);
      }), source.attributesChanged);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      return {
        updatedWindows: conversions.asObjectArray(source, 'updatedWindows', function (obj) {
          return _this3.conflictNodeConverter.toDocument(obj, conversions);
        }),
        updatedWindowItems: conversions.asObjectArray(source, 'updatedWindowItems', function (obj) {
          return _this3.conflictNodeConverter.toDocument(obj, conversions);
        }),
        insertedWindows: conversions.asObjectArray(source, 'insertedWindows', function (obj) {
          return _this3.conflictNodeConverter.toDocument(obj, conversions);
        }),
        insertedWindowItems: conversions.asObjectArray(source, 'insertedWindowItems', function (obj) {
          return _this3.conflictNodeConverter.toDocument(obj, conversions);
        }),
        deletedWindows: conversions.asObjectArray(source, 'deletedWindows', function (obj) {
          return _this3.conflictNodeConverter.toDocument(obj, conversions);
        }),
        deletedWindowItems: conversions.asObjectArray(source, 'deletedWindowItems', function (obj) {
          return _this3.conflictNodeConverter.toDocument(obj, conversions);
        }),
        attributesChanged: source.attributesChanged
      };
    }
  }]);

  return ForecastSimulationConflictDTOConverterImpl;
}(ForecastSimulationConflictDTOConverter_1.ForecastSimulationConflictDTOConverter);

ForecastSimulationConflictDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ForecastSimulationConflictNodeDTOConverter_1.ForecastSimulationConflictNodeDTOConverter])], ForecastSimulationConflictDTOConverterImpl);
exports.ForecastSimulationConflictDTOConverterImpl = ForecastSimulationConflictDTOConverterImpl;